/*
 * © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import { createTheme } from '@mui/system';
import { PROMETHEAN_BLUE } from '../../styles/colors/colors';
export var textTooltipTheme = function textTooltipTheme(_ref) {
  var direction = _ref.direction;
  return createTheme({
    components: {
      MuiStack: {
        styleOverrides: {
          root: {
            '&.EmbersTextTooltip-noWrap': {
              flex: 1,
              minWidth: 0,
              '.EmbersTypography-root': {
                flex: 1,
                width: 0
              },
              '.EmbersStatusIcon-icon': {
                verticalAlign: 'middle'
              }
            },
            '&.EmbersTextTooltip-align-center': {
              alignItems: 'center'
            },
            '.EmbersTitle-tooltip-iconContainer': {
              cursor: 'pointer',
              marginLeft: 8,
              border: 'none',
              padding: 0,
              background: 'none',
              '&:focus-visible > .EmbersStatusIcon-icon': {
                outline: "2px solid ".concat(PROMETHEAN_BLUE)
              }
            },
            '.EmbersStatusIcon-icon': {
              lineHeight: 'inherit !important',
              verticalAlign: 'top'
            },
            '&.EmbersTextTooltip-multipleLine': {
              '.EmbersTitle-tooltip-iconContainer': {
                display: direction === 'rtl' ? 'inline-block' : 'initial',
                '.EmbersStatusIcon-icon': {
                  lineHeight: 'initial !important',
                  verticalAlign: 'middle'
                }
              }
            },
            '&.EmbersTextTooltip-touchDevice': {
              '>:not(style)+:not(style)': {
                position: 'relative',
                width: 32,
                marginLeft: 0,
                WebkitTapHighlightColor: 'transparent',
                // On mobile/tablet, it requests a larger clickable area
                '.EmbersTitle-tooltip-iconContainer': {
                  position: 'absolute',
                  marginLeft: 0,
                  left: 0,
                  width: 32,
                  height: 40,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }
              },
              '.EmbersTypography-root > span': {
                position: 'relative',
                display: 'inline-block',
                verticalAlign: 'top',
                width: 32,
                height: 24,
                '.EmbersTitle-tooltip-iconContainer': {
                  position: 'absolute',
                  marginLeft: 0,
                  left: 0,
                  width: 32,
                  height: 40,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }
              },
              '&.EmbersTextTooltip-align-center': {
                '.EmbersTitle-tooltip-iconContainer': {
                  top: -39,
                  transform: 'translateY(50%)'
                }
              }
            }
          }
        }
      }
    }
  });
};